import React from "react";
import { Box, Container, Heading, Text, UnorderedList, ListItem, Link } from "@chakra-ui/react";

const brand = { green: "#1C4C3F", ink: "#0E2721" };

export default function PrivacyPage() {
  return (
    <Box bg="#F7F5EB" color={brand.ink}>
      <Container maxW="4xl" px={{ base: 4, md: 6 }} py={{ base: 10, md: 14 }}>
        <Heading size="lg" mb={2}>ShelfKey Privacy Policy</Heading>
        <Text fontSize="sm" opacity={0.7} mb={8}>
          Last updated: {new Date().toLocaleDateString()}
        </Text>

        <Heading size="md" mt={6} mb={2}>1. Overview</Heading>
        <Text mb={4}>
          ShelfKey respects your privacy. This policy explains what data we collect, how it’s used,
          and the choices you have.
        </Text>

        <Heading size="md" mt={6} mb={2}>2. Information We Collect</Heading>
        <UnorderedList mb={4}>
          <ListItem><strong>Account info:</strong> email and password when you sign up.</ListItem>
          <ListItem><strong>Usage data:</strong> interactions with AI agents, charts generated, and files you upload.</ListItem>
          <ListItem><strong>Support:</strong> communications if you contact us.</ListItem>
        </UnorderedList>

        <Heading size="md" mt={6} mb={2}>3. How We Use Data</Heading>
        <UnorderedList mb={4}>
          <ListItem>To provide, improve, and secure the Service.</ListItem>
          <ListItem>To generate outputs (charts, insights, recommendations) based on your inputs.</ListItem>
          <ListItem>To communicate with you about your account or updates.</ListItem>
        </UnorderedList>

        <Heading size="md" mt={6} mb={2}>4. Your Control</Heading>
        <UnorderedList mb={4}>
          <ListItem>We do not train models on your private files or chats.</ListItem>
          <ListItem>You can delete datasets, charts, and chat history at any time.</ListItem>
          <ListItem>Account deletion requests permanently remove your data from our systems.</ListItem>
        </UnorderedList>

        <Heading size="md" mt={6} mb={2}>5. Sharing</Heading>
        <Text mb={4}>
          We do not sell your data. We only share with trusted infrastructure providers
          (e.g., hosting, storage) necessary to operate the Service.
        </Text>

        <Heading size="md" mt={6} mb={2}>6. Security</Heading>
        <Text mb={4}>
          We use TLS in transit, AES-256 at rest, and per-workspace isolation. No human can
          access your data unless you explicitly request support.
        </Text>

        <Heading size="md" mt={6} mb={2}>7. Changes</Heading>
        <Text mb={4}>
          We may update this Privacy Policy from time to time. Continued use of ShelfKey
          means you accept the updated policy.
        </Text>

        <Heading size="md" mt={6} mb={2}>8. Contact</Heading>
        <Text>
          Questions? Email{" "}
          <Link href="mailto:hello@shelfkey.app" color={brand.green} textDecoration="underline">
            hello@shelfkey.app
          </Link>
        </Text>
      </Container>
    </Box>
  );
}
